module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/kendall-poster-83ed44690b7691303424744d08816406.jpg";